import { ColumnDef, ModelDef } from '@shared/model'
import { AxE2ConfigModelDef } from '../services/$AxE2Config'
import { $axFrontendHelper } from '../services/$axFrontendHelper'
import { $toast } from '../services/$toast'
import { $appHook } from '@shared/model/$appHook'
import { $AxE2AppHooks } from '../services/$AxE2AppHooks'

interface Columns {
  [colName: string]: ColumnDef
}

export const inquiryTitle = {
  1: 'ご注文・お支払に関するお問い合わせ',
  2: '発送に関するお問い合わせ',
  3: '定期コースの解約/休止',
  4: '商品に関するお問い合わせ',
  5: 'ご意見、ご要望',
  6: 'その他',
  7: 'クーポンご利用について',
}

export const inquiryColumn = {
  custom:{
    family_name:'',
    reputation:'',
    family_name_kana:'',
    reputation_kana:'',
    cloudk_memberid: '',
  },
  tel_primary:'',
  email:'',
  emailConfirmation:'',
  body:'',
  title:'',
  bodyText:'',

}

export const telValidator = (value) => {
  if (value.length != 10 && value.length != 11) {
    return '10桁または11桁でご入力ください。'
  }
  return
}

export const is_intphone = (value) => {
  const int = /[0-9]/
  const isValid = int.test(value)
  if(!isValid){
    return '電話番号を正しく入力してください'
  }
}

export const isNotEmpty = (value) => {
  const str = value.toString()
  if(str.match(/^[\s\t\r\n]*$/)){
    return '入力必須です'
  }
}

export const isNotEmptySelect = (value,name) => {
  const str = value.toString()
  if(str.match(/^[\s\t\r\n]*$/)){
    return name+ 'を選択してください'
  }
}

export const is_email = (value) => {
  if(!value.match("^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$")){
    return 'メールアドレスの形式で入力してください'
  }
}

export const sameWithEmail = (emailconfirm,email) => {
  if(!isNotEmpty(email) && !isNotEmpty(emailconfirm)){
    if (emailconfirm && emailconfirm !== email) {
      return '確認用メールアドレスが間違っています'
    }
  }
}

export const userColumns: Columns = {
  id: {
    type: 'STRING',
    visible: false,
  },
  family_name:{
    type: 'STRING',
    label: '姓',
    validate: {isNotEmpty}
  },
  reputation:{
    type: 'STRING',
    label: '名',
    validate: {isNotEmpty}
  },
  family_name_kana:{
    type: 'STRING',
    label: 'セイ',
    validate: {isNotEmpty}
  },
  reputation_kana:{
    type: 'STRING',
    label: 'メイ',
    validate: {isNotEmpty}
  },
  email: {
    type: 'STRING',
    label: 'メール',
    validate: { is_email,isNotEmpty}
  },
  emailConfirmation: {
    type: 'STRING',
    label: 'メール(確認)',
    validate: { sameWithEmail,is_email,isNotEmpty}
  },
  tel_primary: {
    type: 'STRING',
    label: '電話番号',
    validate: {
      is_intphone,
      isNotEmpty
    },
  },
  title: {
    type: 'TEXT',
    label: 'お問い合わせの項目',
    validate: { isNotEmptySelect },
  },
  bodyTxt: {
    type: 'TEXT',
    label: 'お問い合わせ内容',
    validate: { isNotEmpty },
  },
}

export const getSiteInformation = async() => {
  try {
    const res = await $axFrontendHelper.request({
      path: '/utility/sites/get',
      data: {
        query: {},
      }
    })
    return res.result;
  }catch(e){
    // console.log(e);
    return;
  }
}

// body本文の整形
export const setbodyFormat = (data) => {
  const now = new Date()
  const nowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(),0, 0, 0);
  const month = nowDate.getMonth() + 1
  const contact_date = nowDate.getFullYear() + '年 '+ month + '月'+ nowDate.getDate() + '日'
  const text = ['───────────────────────────────────',
                 '■お問い合わせ内容',
                 '───────────────────────────────────',
                 `・お問い合わせ日　　　${contact_date}`,
                 `・お客様名　　　　　　${data.custom.family_name + ' ' +data.custom.reputation}様`,
                 `・お客様番号　　　　　${data.custom.cloudk_memberid ? data.custom.cloudk_memberid : 'なし'}`,
                 `・電話番号　　　　　　${data.tel_primary}`,
                 `・メールアドレス　　　${data.email}`,
                 `・お問い合わせの項目　${data.title}`,
                 '・お問い合わせ内容',
                 ` ${data.bodyText}`
                ].join('\n')
  data.body = text
}

// お問い合わせAPI実行
export const executeContact = async (data) => {
  // body本文の整形を実施
  setbodyFormat(data)
  try {
    const res = await $axFrontendHelper.request({
      path: '/utility/sites/get',
      data: {
        query: {},
      },
    })

    if ($appHook.hasHook($AxE2AppHooks.editInquiryMailBody)) {
      $appHook.callHooks($AxE2AppHooks.editInquiryMailBody, data, this)
    }

    if (
      res.result.fqdn == 'www.every-house.jp' ||
      res.result.fqdn == 'cms2-housefoods3.demo.axcommerce-dev.jp' ||
      res.result.fqdn == 'cms3-housefoods3.demo.axcommerce-dev.jp'
    ) {
      data['reply_to_header_to_manager'] = 'member@every-house.jp'
    }
    await $axFrontendHelper.request({
      path: '/utility/inquiries/put',
      data: {
        query: {
          inquiry: data,
        },
      },
    })
    // $toast.success('問い合わせを送信成功しました。後日、入力されたメールアドレスに担当者から返信いたします。')
    if ($appHook.hasHook($AxE2AppHooks.contactSubmitAfter)) {
      $appHook.callHooks($AxE2AppHooks.contactSubmitAfter, null, this)
    }
    // throw new Error
    return true
  } catch (e) {
    $toast.error('エラーが発生しました。再度お試しください。')
    return false
  }
}

export const inquiry: ModelDef & AxE2ConfigModelDef<any> = {
  tableName: 'inquiry',
  tableLabel: 'お問い合わせ',
  defaultSort: { key: 'createdAt', order: 'desc' },
  timestamps: false,
  columns: userColumns,
  onSubmitFunction: executeContact,
}

// バリデーション
export const validate = (data,errors) => {
  const colDef = userColumns
  let col = {}
  let colData = {}
  errors.flag = false

  // カラムカスタムは一度、カスタム名を削除し、再度、カスタムなしのカラム名にする
  for(const keyname in data){
    if(keyname === 'custom'){
      for(const custom_keyname in data[keyname]){
        col[custom_keyname] = data[keyname][custom_keyname]
      }
    }
  }
  colData = Object.assign(col,data)
  delete colData['custom']

  // エラーチェック処理
  for(const keyname in colData){
    errors[keyname] = {}
    if(colDef[keyname] && colDef[keyname].validate){
      let err = []
      Object.keys(colDef[keyname].validate).map((key) => {
        let errormessage = '';
        const labelname = colDef[keyname].label
        if(key == 'sameWithEmail'){
          errormessage = colDef[keyname].validate[key](colData[keyname],colData['email'])
        }else{
          errormessage = colDef[keyname].validate[key](colData[keyname],labelname)
        }

        // エラーメッセージがある場合にエラー内容を追加する
        if(errormessage){
          err.push(errormessage)
          // debug
          // console.log(`エラー: ${keyname} => `+ labelname + ':' + errormessage)
        }
      })

      if(err.length !== 0){
        errors[keyname].message = err.join(',')
        // 各カラムのエラー有効
        errors[keyname].flag = true
        // 全カラムのエラー有効
        errors.flag = true
      }
    }
  }
}
